import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {EngineTabTypes} from './models/engine-tab-types.enum';
import {HolidaySearchParams} from '../booking-flow/holiday/holiday-search-page/interfaces/holiday-search-params';
import {ModalStatusService} from '../shared/services/modal-status.service';
import {Observable, Subscription} from 'rxjs';
import {WidgetService} from '../shared/services/widget.service';
import {HolidaySearchFilterService} from "../booking-flow/holiday/holiday-search-page/services/holiday-search-filter.service";
import {PostMessageService} from "../shared/services/post-message.service";
import {ICruiseSearchParams} from "../booking-flow/cruise/cruise-search-page/interfaces/icruise-search-params";
import { TourSeachParams } from '../booking-flow/tour/tour-search-page/interfaces/itour-search-params';

@Component({
  selector: 'app-search-engine',
  templateUrl: './search-engine.component.html',
  styleUrls: ['./search-engine.component.scss']
})
export class SearchEngineComponent implements OnInit, OnDestroy {

  home;
  @Input() selectedTab: EngineTabTypes;
  @Input() holidaySearchParams: HolidaySearchParams;
  @Input() cruiseSearchParams: ICruiseSearchParams;
  @Input() tourSearchParams: TourSeachParams;

  hasOpenModals$: Observable<boolean>;
  isWidget$: Observable<boolean>;
  isB2B$: Observable<boolean>;

  private hasOpenModalsSubscription: Subscription;

  constructor(private _modalStatusService: ModalStatusService,
              private _postMessageService: PostMessageService,
              private _widgetService: WidgetService) { }

  ngOnInit(): void {
    this.hasOpenModals$ = this._modalStatusService.hasOpenModals;
    this.isWidget$ = this._widgetService.isWidget();
    this.isB2B$ = this._postMessageService.isB2B();

    this.hasOpenModalsSubscription = this.hasOpenModals$.subscribe((hasOpenModals) => {
      const bodyEl = document.querySelector('#body-el');
      if (hasOpenModals) {
        bodyEl.classList.add('block-page-scroll');
      } else {
        bodyEl.classList.remove('block-page-scroll');
      }
    });
  }

  ngOnDestroy(): void {
    this.hasOpenModalsSubscription?.unsubscribe();
  }

  onSelectedTab(tabId: EngineTabTypes): void {
    this.selectedTab = tabId;
  }

}
